import { List } from 'immutable';

export class Page<T> {
  content: List<T>;
  number: number;
  size: number;
  totalElements: number;
  totalPages: number;
  numberOfElements: number;
  sort: List<Object>;

  static empty<T>(): Page<T> {
    let pageObj = new Page<T>();
    pageObj.content = List<T>();
    pageObj.number = 0; // the page number
    pageObj.size = 25; // the maximum number of elements for each page
    pageObj.totalElements = 0; // the total number of elements for all pages
    pageObj.totalPages = 0; // the total number of pages
    pageObj.numberOfElements = 0; // the total number of elements on this page
    pageObj.sort = List<Object>();

    return pageObj;
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/shared/models/page.ts